import { FormControl, Grid2 } from '@mui/material';
import { GenericModal, RichTextComponent } from 'app/shared/components';
import { LabelCreateQuestion } from './style'; // Assumindo que 'style' é compartilhado ou similar
import { TextInput } from 'pages/auth/components';
import { Controller, useForm } from 'react-hook-form';
import { useService } from 'app/shared/hooks';
import { updateServiceCategoria } from 'app/services/serviceCategoria'; // Importe a função de edição de seção
import toastr from 'toastr';
import { useEffect, useState } from 'react';

const EditSecaoModal = ({
  open,
  onClose,
  secao, // Propriedade 'secao' contendo id, nome, descricao
  onSuccess,
}) => {
  const { handleSubmit, control, reset, watch } = useForm({
    defaultValues: {
      nome: secao?.nome || '', // Inicializa com o nome da seção
    },
  });
  const watchNome = watch('nome', secao?.nome);
  const [plainText, setPlainTextDescricao] = useState(secao?.descricao || '');
  const [descricaoEdit, setDescricao] = useState(secao?.descricao || '');

  // Atualiza os estados locais quando a prop 'secao' muda
  useEffect(() => {
    if (secao) {
      reset({ nome: secao.nome });
      setPlainTextDescricao(secao.descricao || '');
      setDescricao(secao.descricao || '');
    }
  }, [secao, reset]);

  const { request, response, retry } = useService(updateServiceCategoria, {
    onSuccess: async (data) => {
      toastr.success('Seção editada com sucesso');
      await reset();
      await onSuccess(data);
      await onClose();
    },
  });

  const onSubmit = () => {
    request({
      nome: watchNome,
      descricao: descricaoEdit,
      id: secao.id, // Usa o ID da seção
    });
  };

  const handleChangeDescricao = (value) => {
    setDescricao(value.html);
    setPlainTextDescricao(value.plainText);
  };

  return (
    <GenericModal
      open={open}
      title="Adicionar/Editar seção"
      preventCloseClickOutside
      hasCloseIcon={false}
      size="md"
      actions={[
        {
          color: 'default',
          onClick: () => {
            reset();
            onClose();
          },
          label: 'CANCELAR',
        },
        {
          label: 'CONFIRMAR',
          disabled: !watchNome || !plainText,
          loading: response.loading,
          onClick: () => {
            onSubmit();
          },
        },
      ]}
    >
      <>
        <Grid2 container size={12}>
          <Grid2 size={12}> {/* Removido o Grid2 de 4 colunas para o ColorPicker */}
            <Grid2 mt={3}>
              <Controller
                control={control}
                name="nome"
                render={({ field }) => (
                  <FormControl fullWidth>
                    <TextInput
                      onChange={field.onChange}
                      defaultValue={secao?.nome} // Usa defaultValue da prop secao
                      required
                      label="Nome (Obrigatório)"
                      fullWidth
                    />
                  </FormControl>
                )}
              />
            </Grid2>
            <Grid2 mt={3}>
              <Grid2>
                <LabelCreateQuestion>Descrição simplificada (Obrigatório):</LabelCreateQuestion>
              </Grid2>
              <Grid2 mt={1}>
                <RichTextComponent defaultValue={secao?.descricao} onChange={handleChangeDescricao} />
              </Grid2>
            </Grid2>
          </Grid2>
        </Grid2>
      </>
    </GenericModal>
  );
};

export default EditSecaoModal;